module.exports = __webpack_public_path__ + "img/watch-front.cb8c2f2a.svg";